import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'km',
  months: ['មករា', 'កុម្ភៈ', 'មីនា', 'មេសា', 'ឧសភា', 'មិថុនា', 'កក្កដា', 'សីហា', 'កញ្ញា', 'តុលា', 'វិច្ឆិកា', 'ធ្នូ'],
  monthsShort: [
    'មករា',
    'កុម្ភៈ',
    'មីនា',
    'មេសា',
    'ឧសភា',
    'មិថុនា',
    'កក្កដា',
    'សីហា',
    'កញ្ញា',
    'តុលា',
    'វិច្ឆិកា',
    'ធ្នូ',
  ],
  weekdays: ['ថ្ងៃ​អាទិត្យ', 'ថ្ងៃ​ចន្ទ', 'ថ្ងៃ​អង្គារ', 'ថ្ងៃ​ពុធ', 'ថ្ងៃ​ព្រហស្បតិ៍', 'ថ្ងៃ​សុក្រ', 'ថ្ងៃ​សៅរ៍'],
  weekdaysMin: ['អា', 'ច', 'អ', 'ព', 'ព្រ', 'សុ', 'ស'],
  weekdaysShort: ['អាទិត្យ', 'ចន្ទ', 'អង្គារ', 'ពុធ', 'ព្រហស្បតិ៍', 'សុក្រ', 'សៅរ៍'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([ម៉ោង​សកល]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([ម៉ោង​សកល]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { other: '%s ឆ្នាំ​មុន' },
    M: { other: '%s ខែមុន' },
    w: { other: '%s សប្ដាហ៍​មុន' },
    d: { other: '%s ថ្ងៃ​​មុន' },
    h: { other: '%s ម៉ោង​មុន' },
    m: { other: '%s នាទី​​មុន' },
    s: { other: '%s វិនាទី​មុន' },
  },
  future: {
    y: { other: '%s ឆ្នាំទៀត' },
    M: { other: '%s ខែទៀត' },
    w: { other: '%s សប្ដាហ៍ទៀត' },
    d: { other: '%s ថ្ងៃទៀត' },
    h: { other: '%s ម៉ោងទៀត' },
    m: { other: '%s នាទីទៀត' },
    s: { other: '%s វិនាទីទៀត' },
  },
  abbr: {
    y: { other: '%s ឆ្នាំ' },
    M: { other: '%s ខែ' },
    w: { other: '%s សប្ដាហ៍' },
    d: { other: '%s ថ្ងៃ' },
    h: { other: '%s ម៉ោង' },
    m: { other: '%s នាទី' },
    s: { other: '%s វិនាទី' },
  },
  justNow: 'អម្បាញ់​មិញ',
  yesterday: 'ម្សិល​មិញ',
  today: 'ថ្ងៃនេះ',
  tomorrow: 'ថ្ងៃស្អែក',
  weekStart: 0,
};
const localeName: LocaleName = 'km';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
